export function mvHoverBubble() {
  const targets = document.querySelectorAll('.js_swichTarget');
  if (!targets.length) return;

  // === 旧ロジック（hover/touch）は一旦コメントアウト ===
  // targets.forEach((el) => {
  //   let timer;
  //
  //   // --- PC: hoverで制御
  //   el.addEventListener('mouseenter', () => {
  //     clearTimeout(timer);
  //     el.classList.add('is_open');
  //   });
  //
  //   el.addEventListener('mouseleave', () => {
  //     timer = setTimeout(() => {
  //       el.classList.remove('is_open');
  //     }, 100);
  //   });
  //
  //   // --- SP: タップで開閉トグル
  //   el.addEventListener('touchend', (e) => {
  //     e.preventDefault(); // リンクなどの誤動作防止
  //     const isOpen = el.classList.contains('is_open');
  //     // 他を閉じる（必要に応じて）
  //     document.querySelectorAll('.js_mvBubble.is_open').forEach((other) => {
  //       if (other !== el) other.classList.remove('is_open');
  //     });
  //     // 自分の状態を切り替え
  //     el.classList.toggle('is_open', !isOpen);
  //   });
  // });

  const list = Array.from(targets);
  if (list.length === 0) return;

  function shuffle(array) {
    const result = array.slice();
    for (let i = result.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
  }

  const order = shuffle(list);
  let currentIndex = 0;

  function applyOpen(index) {
    list.forEach((el, i) => {
      el.classList.toggle('is_open', i === index);
    });
  }

  // 初回に1つ開く
  applyOpen(list.indexOf(order[currentIndex]));

  // 3秒ごとにランダム順で切り替え（ロード時に決定）
  setInterval(() => {
    currentIndex = (currentIndex + 1) % order.length;
    applyOpen(list.indexOf(order[currentIndex]));
  }, 3000);
}
